import React, { useState, useEffect } from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "../../../revvComponents";

import { RevvForm } from "../../../commonComponents";

import {
  MetaFieldInitialValuesMap,
  MetaFieldComponentRules,
  MetaFieldComponentMessages,
} from "./MetaFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../actions";

const {
  toggleDynamicFieldView,
  // setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
  setFlagForCommonFields,
} = DocumentTemplateActions;

const MetaFieldSingleSelect = props => {
  const [singleSelectFieldValues, getDataForPrepopulateData] = useState([]);

  const getPreselectedDefaultItem = data => {
    const returnData = [];
    if (data.options && data.options.length > 0) {
      for (let x = 0; x < data.options.length; x += 1) {
        returnData.push(undefined);
        if (data.options[x] === data.default) {
          returnData[x] = true;
        }
      }
    }
    return returnData;
  };

  const getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(MetaFieldInitialValuesMap.SINGLE_SELECT),
    );
    if (propsData.meta) {
      returnData = {
        options: propsData.meta.options,
        default: getPreselectedDefaultItem(propsData.meta),
      };
    }
    getDataForPrepopulateData(returnData);
  };
  useEffect(() => {
    getDataForPrepopulate(props);
    props.setFlagForDefault(true);
  }, []);

  const getDefualtValue = data => {
    let defaultData = "";
    if (data && data.default && data.default.length > 0) {
      for (let v = 0; v < data.default.length; v += 1) {
        if (data.default[v] === true) {
          if (data.options[v] !== "") {
            defaultData = data.options[v];
          }
        }
      }
    }
    return defaultData;
  };

  const getDefualtOptions = data => {
    const optionsData = [];
    if (data && data.options && data.options.length > 0) {
      for (let v = 0; v < data.options.length; v += 1) {
        if (data.options[v] !== "") {
          optionsData.push(data.options[v]);
        }
      }
    }
    return optionsData;
  };

  const showDupPos = arr => {
    let result = [];
    const positions = {};
    // collect all positions
    arr.forEach((value, pos) => {
      positions[value] = positions[value] || [];
      positions[value].push(pos);
    });
    // check how much of same value in string
    Object.keys(positions).forEach(value => {
      const posArray = positions[value];
      if (posArray.length > 1) {
        result = result.concat(posArray);
      }
    });
    return result.sort();
  };

  const buttonValidation = options => {
    if (options && options.length > 0) {
      const duplicate = showDupPos(options);
      if (duplicate.length > 0) {
        props.metaValidStatus(false);
        return;
      }
      let check = false;
      options.forEach(d => {
        if (d === "") {
          check = true;
          props.metaValidStatus(false);
        } else if (d !== "" && check === false) {
          props.metaValidStatus(true);
          props.setFlagForDefault(true);
        }
      });
    }
  };

  // const buttonValidation = options => {
  //   const duplicate = showDupPos(options);
  //   if (duplicate.length > 0) {
  //     props.metaValidStatus(false);
  //     return;
  //   }
  //   let check = false;
  //   options.forEach(d => {
  //     if (d === "") {
  //       check = true;
  //       props.metaValidStatus(false);
  //     } else if (d !== "" && check === false) {
  //       props.metaValidStatus(true);
  //       props.setFlagForDefault(true);
  //     }
  //   });
  // };
  // console.log(showDupPos(arr));

  // render() {
  //   const { singleSelectFieldValues } = this.state;
  return (
    <React.Fragment>
      {
        <RevvForm
          initialFormValue={singleSelectFieldValues}
          customFieldName="SINGLE_SELECT"
          validateOnChange
          customFieldComponentRules={MetaFieldComponentRules}
          customFieldComponentMessages={MetaFieldComponentMessages}
          render={formProps => {
            const {
              handleChangeInList,
              handleAddToList,
              handleRemoveFromList,
              messages,
              touched,
              errors,
              values,
              isValid,
            } = formProps;
            const allInAll = {
              isValid,
              messages,
              touched,
              errors,
              values,
            };
            buttonValidation(values.options);
            const dataCommunication = {
              default: getDefualtValue(values),
              options: getDefualtOptions(values),
            };
            props.setMetaFieldValues(dataCommunication);
            console.debug("allInAll", allInAll, dataCommunication);

            const updateOptions = () => {
              handleAddToList("options", "");
              handleAddToList("default", false);
            };

            const removeField = index => {
              handleRemoveFromList("options", index);
              handleRemoveFromList("default", index);
            };

            const reOrderDefaults = (event, i) => {
              handleChangeInList(event, i);
              // If this is checked then everything else should be unchecked
              if (event.target.checked) {
                values.default.forEach((defaultValue, index) => {
                  if (i !== index) {
                    // Create a dummy event object since we are dealing with js events in revvform
                    event = { target: { name: "default", checked: false } };
                    handleChangeInList(event, index);
                  }
                });
              }
            };

            return (
              values &&
              values.options &&
              values.options.length > 0 &&
              values.options.map((data, i) => (
                <React.Fragment>
                  <div className="revv-form-items">
                    <div className="custom-feild-formitem">
                      <div className="revvform-label">
                        Value({i + 1})
                        <span className="requiredwitherr-input">*</span>
                      </div>

                      <div className="checkboxpos">
                        <div>
                          <Input
                            name="default"
                            type="checkbox"
                            data-test="SingleSelectField-checkbox"
                            checked={values.default[i]}
                            className="errorborder marright"
                            onChange={event => reOrderDefaults(event, i)}
                          />
                          <span className="revvform-label">
                            This is default value
                          </span>
                        </div>
                        {values.options.length > 2 && (
                          <div className="customselect-delete-option">
                            <span
                              className="btn-icon"
                              onClick={() => removeField(i)}
                              onKeyPress={() => removeField(i)}
                              role="button"
                              tabIndex="0">
                              <FontAwesomeIcon icon={["far", "trash-alt"]} />
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <Input
                      name="options"
                      type="text"
                      data-test="SingleSelectField-text"
                      value={values.options[i]}
                      placeholder="Enter field value"
                      className="metafield-create-input dynamicfieldcustom-footer-input errorborder"
                      onChange={event => handleChangeInList(event, i)}
                    />
                  </div>
                  {values.options.length - 1 === i && (
                    <div className="clause-options-add-option">
                      <Button
                        data-test="checkboxfield-addoption-button"
                        className="revv-btn-secondary-sm"
                        onClick={() => updateOptions()}
                        onKeyPress={() => updateOptions()}
                        role="button"
                        tabIndex="0">
                        <i>
                          <FontAwesomeIcon
                            icon={["far", "plus-circle"]}
                            className=""
                          />
                        </i>
                        Add another value
                      </Button>
                    </div>
                  )}
                </React.Fragment>
              ))
            );
          }}
        />
      }
    </React.Fragment>
  );
  // }
};

const mapStateToProps = state => {
  const { meta } =
    state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  // setMetaFieldValues,
  setFlagForCommonFields,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MetaFieldSingleSelect);
